import { types } from "../types/types";

const initialState = {
    isLoading:true,
    reclamos: [],
    reclamoActivo: null
}

export const reclamoReducer = ( state=initialState, action )=> {

    switch (action.type) {

        case types.getReclamoLoading:
            return {
                ...state,
                isLoading: false,
                reclamos:[...action.payload]
            }
        case types.changeLoading:
            return{
                ...state,
                isLoading:true
            }
        case types.setReclamoActivo:
            return{
                ...state,
                reclamoActivo: action.payload
            }
        case types.clearReclamoActive:
            return{
                ...state,
                reclamoActivo: null
            }
        default:
            return state;
    }

}